import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ClipboardDocumentCheckIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/clipboard-document-check"><g id="Icon"><path fillRule="evenodd" clipRule="evenodd" d="M21.5999 6.3002C21.5999 4.90533 20.5422 3.75751 19.185 3.61507C19.0426 2.25793 17.8948 1.2002 16.4999 1.2002H14.6999C13.305 1.2002 12.1572 2.25793 12.0148 3.61507C10.9647 3.72529 10.0938 4.43743 9.75354 5.4002H13.1999C14.8568 5.4002 16.1999 6.74334 16.1999 8.4002V16.8002H18.8999C20.3911 16.8002 21.5999 15.5914 21.5999 14.1002V6.3002ZM14.6999 3.0002C14.2028 3.0002 13.7999 3.40314 13.7999 3.9002V4.2002H17.3999V3.9002C17.3999 3.40314 16.997 3.0002 16.4999 3.0002H14.6999Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M3.60002 7.20019C2.93728 7.20019 2.40002 7.73745 2.40002 8.4002V20.4002C2.40002 21.0629 2.93728 21.6002 3.60002 21.6002H13.2C13.8628 21.6002 14.4 21.0629 14.4 20.4002V8.4002C14.4 7.73745 13.8628 7.20019 13.2 7.20019H3.60002ZM11.8489 12.1994C12.1246 11.7858 12.0128 11.2271 11.5993 10.9513C11.1857 10.6756 10.6269 10.7874 10.3512 11.201L7.36014 15.6875L6.33642 14.6638C5.98495 14.3123 5.4151 14.3123 5.06363 14.6638C4.71216 15.0153 4.71216 15.5851 5.06363 15.9366L6.86363 17.7366C7.05429 17.9272 7.32039 18.0224 7.58871 17.9958C7.85703 17.9692 8.0993 17.8238 8.24887 17.5994L11.8489 12.1994Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ClipboardDocumentCheckIcon;